// 时间范围选择器（预设 + 自定义）
import { DatePicker } from 'antd'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs, { type Dayjs } from 'dayjs'

const { RangePicker } = DatePicker

export type PresetKey = 'today' | '7d' | '30d' | '90d' | 'all' | 'custom'

interface Props {
  value?: [Dayjs, Dayjs]
  onChange?: (range: [Dayjs, Dayjs] | null, preset: PresetKey) => void
  className?: string
  allowClear?: boolean
}

const PRESETS: Array<{ key: PresetKey; label: string; getRange: () => [Dayjs, Dayjs] }> = [
  { key: 'today', label: '今天', getRange: () => [dayjs().startOf('day'), dayjs().endOf('day')] },
  { key: '7d', label: '7d', getRange: () => [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')] },
  { key: '30d', label: '30d', getRange: () => [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')] },
  { key: '90d', label: '90d', getRange: () => [dayjs().subtract(89, 'day').startOf('day'), dayjs().endOf('day')] },
  { key: 'all', label: '全部', getRange: () => [dayjs('2020-01-01'), dayjs().endOf('day')] },
]

export default function DateRangePicker({ value, onChange, className, allowClear = false }: Props) {
  const handlePreset = (key: PresetKey) => {
    const preset = PRESETS.find((p) => p.key === key)
    if (!preset) return
    const range = preset.getRange()
    onChange?.(range, key)
  }

  const handleRange: RangePickerProps['onChange'] = (dates) => {
    if (!dates || !dates[0] || !dates[1]) {
      onChange?.(null, 'custom')
      return
    }
    onChange?.([dates[0], dates[1]], 'custom')
  }

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className ?? ''}`}>
      <div className="flex items-center gap-1">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => handlePreset(p.key)}
            className="px-2.5 py-1 text-xs rounded-md border border-ink-100 text-ink-700 hover:bg-ink-50 hover:border-ink-200 transition-colors"
          >
            {p.label}
          </button>
        ))}
      </div>
      <RangePicker
        size="middle"
        value={value}
        onChange={handleRange}
        allowClear={allowClear}
        placeholder={['开始日期', '结束日期']}
        className="!text-sm"
      />
    </div>
  )
}
